import "./Home.css";
import { FaBed, FaBath, FaRulerCombined } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // ✅ NEW STATE FOR POPUP
  const [showForm, setShowForm] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  const propertiesPerPage = 10;

  useEffect(() => {
    fetch("https://urbanbrick.in.net/get-properties.php")
      .then(res => res.json())
      .then(data => {

        const cleaned = data.map((item) => ({
          ...item,
          images: Array.isArray(item.images)
            ? item.images
            : item.images
              ? JSON.parse(item.images)
              : []
        }));

        setProperties(cleaned);

      })
      .catch(err => console.log(err));
  }, []);

  const indexOfLastProperty = currentPage * propertiesPerPage;
  const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;

  const currentProperties = properties.slice(
    indexOfFirstProperty,
    indexOfLastProperty
  );

  const totalPages = Math.ceil(properties.length / propertiesPerPage);

  return (
    <>

      {/* HERO (UNCHANGED) */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="hero-text">

            <h1>
              Find Your Dream Property with <br />
              <span>Urban Brick Real Estate Broking Co</span>
            </h1>

            <div className="hero-buttons">

              <a href="tel:+919876543210" className="call-btn">
                📞 Call Now
              </a>

              <a
                href="https://wa.me/919876543210"
                target="_blank"
                className="whatsapp-btn"
              >
                💬 WhatsApp
              </a>

            </div>

          </div>
        </div>
      </section>

      {/* PROPERTY SECTION */}
      <section className="property-section">

        <h2 className="property-title">Latest Properties</h2>

        <div className="property-grid">

          {currentProperties.map((property, index) => (

            <div className="property-card" key={index}>

              <div className="property-image-box">

                <span className="property-badge">
                  For {property.listingType}
                </span>

                <img
                  src={
                    property.images?.[0]
                      ? `https://urbanbrick.in.net/uploads/${property.images[0]
                          .split("/")
                          .pop()
                          .replaceAll(" ", "%20")}`
                      : "https://via.placeholder.com/300"
                  }
                  alt="property"
                />

              </div>

              <div className="property-info">

                <h3>{property.listingType}</h3>

                <p>📍 {property.location}</p>

                <p><b>Type:</b> {property.property_type || "N/A"}</p>

                <p><b>Price:</b> ₹ {property.price}</p>

                <p><b>Posted By:</b> {property.postedBy}</p>

                <p><b>Status:</b> {property.status}</p>

                {/* ✅ VIEW DETAILS FIX */}
                <button
  className="view-details-btn"
  onClick={() => {
    setSelectedProperty(property);
    setShowForm(true);
  }}
>
  View Details
</button>

              </div>

            </div>

          ))}

        </div>

        {/* PAGINATION (UNCHANGED) */}
        <div className="pagination">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={currentPage === index + 1 ? "active" : ""}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>

      </section>

      {/* ✅ POPUP FORM (NEW ADDITION) */}
      {showForm && selectedProperty && (
  <div className="popup-overlay">
    
    <div className="popup-form">

      <h3>Property Enquiry</h3>

      <img
        src={
          selectedProperty.images?.[0]
            ? `https://urbanbrick.in.net/uploads/${selectedProperty.images[0]
                .split("/")
                .pop()}`
            : "https://via.placeholder.com/300"
        }
        alt=""
      />

      <input value={selectedProperty.listingType || ""} readOnly />
      <input value={selectedProperty.location || ""} readOnly />
      <input value={selectedProperty.price || ""} readOnly />

      <input id="name" placeholder="Your Name" />
      <input id="phone" placeholder="Phone" />
      <textarea id="message" placeholder="Message" />

      <button
        onClick={() => {

          const name = document.getElementById("name").value;
          const phone = document.getElementById("phone").value;
          const message = document.getElementById("message").value;

          const text = `
🏠 Property Enquiry
Type: ${selectedProperty.listingType}
Location: ${selectedProperty.location}
Price: ${selectedProperty.price}

Name: ${name}
Phone: ${phone}
Message: ${message}
          `;

          window.open(
            `https://wa.me/91XXXXXXXXXX?text=${encodeURIComponent(text)}`,
            "_blank"
          );
        }}
      >
        Submit
      </button>

      <button onClick={() => setShowForm(false)}>
        Close
      </button>

    </div>

  </div>
)}
      

      {/* FAQ */}
      <section className="faq-section">
        <div className="faq-header">
          <h4>FAQ</h4>
          <h2>Frequently Asked Questions</h2>
          <p className="faq-desc">
            Find answers to common questions related to property buying,
            selling and investment with Pillar.
          </p>
        </div>

        <div className="faq-container">
          <details className="faq-item">
            <summary>How can I buy a property through Pillar?</summary>
            <p>You can explore listings, connect with agents, and book property visits easily through our platform.</p>
          </details>

          <details className="faq-item">
            <summary>Is there any registration fee?</summary>
            <p>No, browsing properties and contacting agents is completely free for users.</p>
          </details>

          <details className="faq-item">
            <summary>Can I list my own property?</summary>
            <p>Yes, property owners can create an account and submit their property for listing.</p>
          </details>

          <details className="faq-item">
            <summary>Do you provide legal support?</summary>
            <p>We connect you with verified experts who can assist with legal documentation.</p>
          </details>

          <details className="faq-item">
            <summary>Are all properties verified?</summary>
            <p>Yes, we verify listings to ensure authenticity and build buyer trust.</p>
          </details>
        </div>
      </section>

      {/* CONTACT  */}
      <section className="contact-section">

        <div className="contact-header">
          <h4>Contact Us</h4>
          <h2>Discuss Your Property Goals</h2>
          <p className="contact-desc">
            Have questions or planning to buy, sell, or rent a property?
            Our team is ready to help you find the best solutions tailored to your needs.
          </p>
        </div>

        <div className="contact-wrapper">

          <div className="contact-form">
            <form>
              <div className="form-row">
                <input type="text" placeholder="Full Name" />
                <input type="email" placeholder="Email Address" />
              </div>

              <textarea placeholder="Additional Message"></textarea>

              <button type="submit">Send Message</button>
            </form>
          </div>

          <div className="contact-map">
            <iframe
              title="map"
              src="https://www.google.com/maps?q=SCF No 8 , Near Masjid , Baltana , Zirakpur , Punjab , 140604&output=embed"
              loading="lazy"
            ></iframe>
          </div>

        </div>
      </section>

    </>
  );
}